define(
  'modules/preload',
  [],
  function () {
    // this is minified and stuck at top of loader.js

var Preload = function() {

};

Preload.prototype.get = function( urls, finishedCallback, updateCallBack ) {

    var my = this;

    //

    var loadedAssets = [];

    var requests = [];

    var status = 0, _status = -1;

    var startTimestamp = Date.now();

    var updateTimestamp = Date.now()-999999999;

    //

    for (let index = 0; index < urls.length; index++) {

        var url = urls[index];
        
        //

        if (url!="") {

            var xhr = new XMLHttpRequest();

            xhr._url = url;

            requests.push(xhr);

            xhr.onload = function(e) {
                if (this.status == 200) {
                    var b = this.response;
                    
                    loadedAssets.push( {
                        url:this._url,
                        blob:b,
                        blobURL: URL.createObjectURL(b),
                    });

                    requests.splice(requests.indexOf(this),1);

                    if (requests.length==0) {
                        
                        my.duration = Date.now()-startTimestamp;
                        finishedCallback(my);

                    }
                }
            };
            
            xhr.onprogress = function(e) {
                
                // loaded/total

                var pSum = 0, tSum = 0;

                e.target._loaded = e.loaded;
                e.target._total = e.total;

                for (let index2 = 0; index2 < requests.length; index2++) {
                    var thisRequest = requests[index2];
                    if (thisRequest._loaded!==undefined) {
                        pSum+=thisRequest._loaded;
                        tSum+=thisRequest._total;
                    }

                }

                if (tSum==0) return;

                //

                var r = pSum/tSum;

                if (r>status) status = r;

                //

                var thisTimestamp = Date.now();

                if ( (thisTimestamp-updateTimestamp>250) & (status!=_status) ) {

                    if (updateCallBack) updateCallBack(status);

                    updateTimestamp = thisTimestamp;

                    _status = status;

                }

            };

            xhr.open('GET', url, true);
            xhr.responseType = 'blob';

            xhr.send();

        }

    }

    my.getItemByURL = function( urlSnippet ) {

        var url = urlSnippet;

        if (url.indexOf("./")!=-1) url = url.split("./").pop();

        for (let index = 0; index < loadedAssets.length; index++) {

            var blobItem = loadedAssets[index];

            if (blobItem.url.indexOf(url)!=-1) return blobItem.blobURL;
            
        }

    }

}

    return Preload;
});

